import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {TransactionResponse} from "./model";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(
    public http: HttpClient,
  ) { }

  getTransactions(): Observable<TransactionResponse[]> {
    return this.http.get<TransactionResponse[]>(environment.apiUrl + "/transactions");
  }


}
